import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { AssetManager } from '../../../../../viewer/asset-manager';
import { ElementObj } from '../../../../../viewer/elements/element-obj';
import { Point2d } from '../../../../../viewer/utilities/math-helpers';
import { ConfirmationDialog } from '../../../confirmation-dialog/confirmation-dialog';
import { InfoBox } from '../../../info-box/info-box';
import { Stack } from '../../../stack/stack';
import { CategoryContext } from '../../state/category-state';

type Props = {
  asset: ElementObj;
  pos?: Point2d;
  onClose: () => void;
};

const DeleteAssetDialog = (props: Props) => {
  const { t } = useTranslation();
  const { refreshAssets } = React.useContext(CategoryContext);

  return (
    <ConfirmationDialog
      confirmationText={t('common.deleteAssetDialog.confirmButton', { ns: 'skyviewAssetMenu' })}
      negative={true}
      pos={props.pos}
      title={t('common.deleteAssetDialog.title', { ns: 'skyviewAssetMenu' })}
      onCancel={props.onClose}
      onConfirm={async () => {
        await AssetManager.instance.delete(props.asset, true);
        refreshAssets();
        props.onClose();
      }}
    >
      <Stack direction="column" spacing={1}>
        <span>
          <Trans
            components={{ bold: <strong /> }}
            i18nKey="common.deleteAssetDialog.text"
            ns="skyviewAssetMenu"
            values={{ assetName: props.asset.name }}
          />
        </span>
        <InfoBox color="red" leftIcon={{ icon: ['fad', 'exclamation'] }}>
          {t('common.deleteAssetDialog.warning', { ns: 'skyviewAssetMenu' })}
        </InfoBox>
      </Stack>
    </ConfirmationDialog>
  );
};

export { DeleteAssetDialog, Props as DeleteAssetDialogProps };
